export default "__VITE_ASSET__DqV8L2d7__"